import React, {useState} from 'react';
import Button from "./common/Button";
import {IIdStatus, IProjectStatus, IUser} from "../types/type";
import {API} from "aws-amplify";
import {toastError} from "../toast";
import {useTranslation} from "react-i18next";


interface IFourthStepBottom {
    liveFormResult : IIdStatus | null
    AllTheCoinsAreCertified : boolean
    step: number
    goNextStep: (AllTheCoinsAreCertified ?: boolean) => void;
    user?: IUser
    projectId: string
    projectStatus : IProjectStatus
    chains: string | string[]
    env : "dev" | "live"
}


const PreAuthenticationBottom: React.FC<IFourthStepBottom> =
    ({
         AllTheCoinsAreCertified,
         step,
         goNextStep,
         liveFormResult,
         user,
         projectId,
         projectStatus,
         chains,
        env
     }) => {

        const [consentRules, setConsentRules] = useState<boolean>(false);
        const [confirmationLoading , setConfirmationLoading] = useState<boolean>(false);
        const {t} = useTranslation();

        const next = async () => {

            if (projectStatus === 'closed') return;




            if (step === 0 && AllTheCoinsAreCertified && liveFormResult === IIdStatus.approved) {

                let preferedOptions = '';

                if (chains && chains.length >= 1) {
                    preferedOptions = (chains as string[]).join("|").trim();
                }


                if (consentRules) {
                    if (user && user.id && user.argosId) {
                        try{
                            if (confirmationLoading) return;
                            setConfirmationLoading(true);
                            const res = await API.post('apiArgosID', `/confirmation?alias=${env}`, {
                                body: {
                                    userId: user.id,
                                    argosId : user.argosId,
                                    projectId,
                                    preferedOptions
                                }
                            })

                            if (res && res.statusCode === 200) {
                                setConfirmationLoading(false);
                                return goNextStep(AllTheCoinsAreCertified);
                            }
                            setConfirmationLoading(false)
                            return toastError("Authentication failed , Please Retry");
                        }catch (e) {

                        }
                    } else {
                        return toastError("User data is missing")
                    }
                }
                return;
            }
            goNextStep();
        }


        return (

            <>
                <style>
                    {`
                        .small-loader:after {
                            background : #3b81f6
                        }    
                    `}

                </style>
                {
                    AllTheCoinsAreCertified &&
                    <div className={'flex text-xs items-center justify-between m-2'}>
                        <div/>
                        <div className={'flex items-center'}>
                            <input id={'accept'} type={'checkbox'}
                                   checked={consentRules} onChange={() => setConsentRules((prev => !prev))}
                            />
                            <label htmlFor={'accept'} className={'ml-2 text-left'}>{t('consent-to-provision')}</label>
                        </div>

                        <a className={'flex items-center'}
                           style={{'minWidth':'60px'}}
                           href={'https://argos.notion.site/Consent-to-provide-personal-information-to-third-parties-8386a4821c0243648daa983787a94eeb'} target={"_blank"}>
                            <span className={'flex-1 cursor-pointer'} >{t('detail')} &rarr;</span>
                        </a>

                    </div>
                }

                <Button
                    onClick={next}
                    conditionalClassName={`
                    ${((AllTheCoinsAreCertified && consentRules) || (!AllTheCoinsAreCertified && step === 0 && (liveFormResult === IIdStatus.approved || liveFormResult === IIdStatus.notApproved || liveFormResult === IIdStatus.rejected) && projectStatus === 'service')) ? 
                        'bg-blue-500 ' : 
                        'bg-blue-300 disabled:opacity-50'}`}
                    value={AllTheCoinsAreCertified ? t('verify-my-identity') : t('continue')}
                    networkLoading={confirmationLoading}
                />
            </>

        )
    }

export default PreAuthenticationBottom;